import * as FiIcons from 'react-icons/fi';
import {
  IconButton as IconButtonBase,
  Flex as FlexBase,
  HStack as HStackBase,
  Link as ChakraLinkBase,
} from '@chakra-ui/react';
import { entradaDoPedido } from '../helpers/entradaPedido';

// Cast Chakra components to bypass TS2590 ("union type too complex").
const IconButton = IconButtonBase as React.ComponentType<any>;
const Flex = FlexBase as React.ComponentType<any>;
const HStack = HStackBase as React.ComponentType<any>;
const ChakraLink = ChakraLinkBase as React.ComponentType<any>;

export function getColumn(
  deleteFunction: (e: any, id: string) => void,
  editPath: string,
  showModalFuntion: (index: number) => void,
  approveFunction: (id: string) => void,
  isGerente: boolean
) {
  const columns: any[] = [
    {
      // Mesmo código que o app mostra (primeiros 8 caracteres do pedido_id),
      // e o accessor devolve esse texto para o filtro da coluna achar o pedido.
      Header: 'Código',
      id: 'codigo',
      accessor: (row: any) => String(row.pedido_id ?? '').substring(0, 8),
      Cell: ({ value }: any) => <span>{value}</span>,
    },
    {
      Header: 'Pedido',
      accessor: 'pedido_erp',
      Cell: ({ row }: any) => <span>{row.original.pedido_erp || '-'}</span>,
    },
    {
      Header: 'Cliente',
      accessor: 'clientes.razao_social',
    },
    {
      Header: 'Vendedor',
      accessor: 'colaboradores.nome',
    },
    {
      Header: 'Data de emissão',
      id: 'dataEmissao',
      // Accessor retorna o momento de entrada para o react-table ordenar
      // cronologicamente (menor = mais antigo, maior = mais recente).
      accessor: (row: any) =>
        entradaDoPedido(row.data_emissao, row.hora_emissao)?.momento.toMillis() ?? 0,
      sortType: 'basic',
      // Dia e hora em que o pedido entrou no Essencial, no horário local.
      // Pedido antigo do Protheus, sem hora gravada, mostra só o dia.
      Cell: ({ row }: any) => {
        const entrada = entradaDoPedido(
          row.original.data_emissao,
          row.original.hora_emissao
        );
        if (!entrada) return '-';
        // Sem quebra: a hora fica na mesma linha da data.
        return (
          <span style={{ whiteSpace: 'nowrap' }}>
            {entrada.temHora
              ? entrada.momento.toFormat("dd/MM/yyyy 'às' HH:mm")
              : entrada.momento.toFormat('dd/MM/yyyy')}
          </span>
        );
      },
    },
    {
      Header: 'Margem Pedido',
      accessor: 'margemPedido',
      Cell: ({ row }: any) => (
        <span>{(row.original.margem_pedido * 100).toFixed(2)}%</span>
      ),
    },
    {
      Header: 'Situação',
      accessor: 'situacao',
    },
    {
      Header: ' ',
      Cell: ({ row }: any) => (
        <Flex as="main" alignItems="center">
          <HStack spacing={2}>
            {/* <ChakraLink
              onClick={(e) => {
                showModalFuntion(Number(row.original.id));
              }}
            >
              <IconButton
                size="sm"
                aria-label="Informações"
                colorScheme="green"
                bg="green.500"
                _hover={{
                  bg: "green.700",
                }}
                icon={<FiIcons.FiInfo size={18} color="#eeeef2" />}
              />
            </ChakraLink> */}
            <ChakraLink href={`${editPath}/${row.original.pedido_id}`}>
              <IconButton
                size="sm"
                aria-label="Informações"
                colorScheme="green"
                bg="green.500"
                _hover={{
                  bg: 'green.700',
                }}
                icon={<FiIcons.FiInfo size={18} color="#eeeef2" />}
              />
            </ChakraLink>
            {/* Aprovação/reprovação agora só dentro do pedido (ListItensOrder),
                não mais pela lista. */}
            {/* <ChakraLink
              onClick={(e) => {
                deleteFunction(e, row.original.id);
              }}
              href="/"
            >
              <IconButton
                size="sm"
                aria-label="Editar"
                colorScheme="red"
                bg="red.500"
                _hover={{
                  bg: "red.700",
                }}
                icon={<FiIcons.FiXSquare size={18} color="#eeeef2" />}
              />
            </ChakraLink> */}
          </HStack>
        </Flex>
      ),
      disableSortBy: true,
      disableFilters: true,
    },
  ];

  return columns;
}
